
import * as domainConstants from "../../../constants/DomainConstants";
import showToastr from "../../../util/toastr.js";

import indienenVoortgangsrapportApi from "../../../api/indienenVoortgangsrapportApi";

import redirector from "../../../util/redirector.js";
import { getStore } from "../../../store/configureStore";

export default class VRIndienenPageHelper {
    constructor(context, redirector) {
        this.dispatch = getStore().dispatch;
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const { vrLoaded, vrProjectId, loadLayout } = this.context.props;

        if (!vrLoaded)
            redirector.goTo("voortgangsrapport/project/" + vrProjectId);

        this.context.props.ajaxStarted();
        indienenVoortgangsrapportApi.get(vrProjectId).then(response => {
            this.context.props.ajaxEnded();

            const indienen = response.data;

            this.context.setState({
                indienen: indienen
            });

            loadLayout(vrProjectId, true);
        }).catch(error => {
            this.context.props.ajaxFailed(error);
            this.context.props.throwException(error);
        });

        this.context.props.getContent(vrProjectId, "dossierPDF")
            .then(result => {
                if (result.success) {
                    const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                    if (pdfFiles) {
                        this.context.setState(
                            {
                                pdf: pdfFiles
                            });
                    }
                }
            });
    }

    unmount() {
        this.handleOnStopInterval();
    }

    onSave(event) {
        event.preventDefault();
        this.context.props.confirmIndienen(this.context.state.indienen.voortgangsrapportId)
            .then(isIngediend => {
                if (isIngediend) {
                    redirector.goTo("/voortgangsrapport/bevestiging");
                }
            });
    }

    handleOnStartInterval() {
        this.context.setState({ pollCount: 0 });
        const timer = setInterval(() => {
            if (this.context.state.pollCount > 19) {
                this.handleOnStopInterval();
            }
            this.context.props.getContent(this.context.state.indienen.voortgangsrapportId, "dossierPDF")
                .then(result => {
                    if (result.success) {
                        const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                        if (pdfFiles) {
                            this.context.setState(
                                {
                                    pdf: pdfFiles
                                });
                            this.handleOnStopInterval();
                        }
                    }
                    this.context.setState({ pollCount: this.context.state.pollCount + 1 });
                }).catch(error => {
                    this.context.props.ajaxFailed(error);
                    this.context.props.throwException(error);
                });
        }, 10000);

        this.context.setState({ timer: timer });
    }

    handleOnStopInterval() {
        this.context.props.ajaxStarted();
        indienenVoortgangsrapportApi.get(this.context.props.params.vrProjectId).then(response => {
            this.context.props.ajaxEnded();

            const indienen = response.data;

            this.context.setState({
                indienen: indienen
            });
        }).catch(error => {
            this.context.props.ajaxFailed(error);
            this.context.props.throwException(error);
        });

        clearInterval(this.context.state.timer);
        this.context.setState({ timer: null });
    }

    onGeneratePdf() {
        this.context.props.generatePdf(this.context.props.params.vrProjectId).then(success => {
            if (success) {
                showToastr(domainConstants.PDF_GENEREREN);
                this.handleOnStartInterval();
            }
        });
    }
}